import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";

type props = {
  text?: string;
  onPress: () => void;
  color?: string;
  btnStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
};

export const BorderButton: React.FC<props> = ({
  text,
  onPress,
  color,
  btnStyle,
  textStyle,
}) => {
  return (
    <div
      onClick={onPress}
      style={{
        width: 55,
        height: 34,
        borderColor: color ?? Colors.darkBrown,
        borderWidth: 2,
        borderStyle: "solid",
        borderRadius: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...btnStyle,
      }}>
      <TCText
        style={{
          fontSize: 12,
          color: color ?? Colors.darkBrown,
          fontWeight: 500,
          paddingBottom: 1,
          ...textStyle,
        }}
        value={text ?? "Edit"}
      />
    </div>
  );
};
